export default __webpack_public_path__ + "static/media/mini-metro@2x.9a0412b1.webp";